
import { WorkOrder } from "@feature/types/job.types";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"


// Define the API slice for WorkOrder operations
export const workOrderApi = createApi({
  reducerPath: "workOrderApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/workorders",
  }),
  tagTypes: ["WorkOrder"],
  endpoints: (builder) => ({
    // Get all work orders
    getWorkOrders: builder.query<WorkOrder[], void>({
      query: () => "",
      providesTags: ["WorkOrder"],
    }),
    // Get single work order by ID
    getWorkOrder: builder.query<WorkOrder, number>({
      query: (id) => `/${id}`,
      providesTags: (result, error, id) => [{ type: "WorkOrder", id }],
    }),
    // Create new work order
    createWorkOrder: builder.mutation<WorkOrder, Partial<WorkOrder>>({
      query: (workOrder) => ({
        url: "",
        method: "POST",
        body: workOrder,
      }),
      invalidatesTags: ["WorkOrder"],
    }),
    // Update existing work order
    updateWorkOrder: builder.mutation<WorkOrder, { id: number; workOrder: Partial<WorkOrder> }>({
      query: ({ id, workOrder }) => ({
        url: `/${id}`,
        method: "PUT",
        body: workOrder,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "WorkOrder", id }],
    }),
    // Delete work order
    deleteWorkOrder: builder.mutation<void, number>({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["WorkOrder"],
    }),
  }),
})

export const {
  useGetWorkOrdersQuery,
  useGetWorkOrderQuery,
  useCreateWorkOrderMutation,
  useUpdateWorkOrderMutation,
  useDeleteWorkOrderMutation,
} = workOrderApi
